import { render, staticRenderFns } from "./create-employee-modal.vue?vue&type=template&id=64031fb8&scoped=true"
import script from "./create-employee-modal.vue?vue&type=script&lang=js"
export * from "./create-employee-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64031fb8",
  null
  
)

export default component.exports